import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { ReactComponent as GcxLogoInvert } from "./../../../../assets/images/gcx-logo.svg";
import { ReactComponent as GcxLogoSmall } from "./../../../../assets/images/gcx-logo-small.svg";
import { ReactComponent as GcxLogoIcon } from "./../../../../assets/images/gcx-logo-icon.svg";

const gcxLogoSmall = <GcxLogoSmall />;
const gcxLogoInvert = <GcxLogoInvert />;
const gcxLogoIcon = <GcxLogoIcon />;

export const GcxLogo = ({ version = "small", customClassname = "" }) => {
  const logoVersion = {
    small: gcxLogoSmall,
    invert: gcxLogoInvert,
    icon: gcxLogoIcon
  };
  return (
    <div className={`gcx-logo ${customClassname}`} data-testid="gcx-logo">
      <NavLink to={INTERNAL_PATHS.HOME} aria-label="GCX home page">
        {logoVersion[version]}
      </NavLink>
    </div>
  );
};
